module.exports = __webpack_public_path__ + "media/csgo_ui_crate_item_scroll.71f91066.wav";